'use strict'
const Base = require('../base.edit.js')

module.exports = class PasswordChangeWidget extends Base {

	onInit() {

	}

}



//////////////////
// WEBPACK FOOTER
// ./src/widgets/password-change/password-change.edit.js
// module id = 481
// module chunks = 0